import { LOCALES } from 'constants/locales';

export const DOMAINS: any = {
  ONEULOOK: 'brand.nmodelin.com',
  KYOLOOK: 'brand.kyolook.com',

  GLOVV_KR: 'brand.glovv.co.kr',
  GLOVV_JP: 'glovv.kyolook.com',
};

export const getCurrentDomain = () => {
  const hostname = window.location.hostname;
  return (
    Object.values(DOMAINS).find((domain) => domain === hostname) ||
    (process.env.LOCALE === LOCALES.JA ? DOMAINS.GLOVV_JP : DOMAINS.GLOVV_KR)
  );
};

export const isOneulook = () => getCurrentDomain() === DOMAINS.ONEULOOK;
export const isKyolook = () => [DOMAINS.KYOLOOK, DOMAINS.GLOVV_JP].includes(getCurrentDomain());
export const isGlovvKr = () => getCurrentDomain() === DOMAINS.GLOVV_KR;
export const isGlovvJp = () => getCurrentDomain() === DOMAINS.GLOVV_JP;
export const isGlovv = () => [DOMAINS.GLOVV_KR, DOMAINS.GLOVV_JP].includes(getCurrentDomain());
export const isKoreaService = () => process.env.LOCALE === LOCALES.KO;
export const isJapanService = () => process.env.LOCALE === LOCALES.JA;
